module.exports = __webpack_public_path__ + "img/qrcode_for_yz.4834c091.jpg";